import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function EntityCardGrid({ items, renderItem, keyExtractor = (item) => item.id, emptyMessage = 'Nenhum registro encontrado.' }) {
  if (!items || items.length === 0) {
    return (
      <Box sx={{ py: 6, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          {emptyMessage}
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={2}>
      {items.map((item) => (
        <Grid item xs={6} sm={4} md={3} lg={2.4} key={keyExtractor(item)}>
          {renderItem(item)}
        </Grid>
      ))}
    </Grid>
  );
}

export default EntityCardGrid;
